import { ConfigExtensionFactory } from '@blocksuite/std';

import type { AppBlockModel } from '../schemas/app-model.js';

export type AppBlockConfig = {
  /** Opens the App of the card; without it the card is display only. */
  openApp?: (app: AppBlockModel) => void;
  /**
   * Shows what the host offers for the App of the card, at `anchor`, the
   * control of the card the actions hang on. With it a click on the card
   * asks for these actions instead of opening the App.
   */
  showActions?: (app: AppBlockModel, anchor: HTMLElement) => void;
};

export const AppBlockConfigExtension =
  ConfigExtensionFactory<AppBlockConfig>('affine:app');
